import { useTranslation } from 'react-i18next';

export default function TemoignageLocal() {
  const { t } = useTranslation('saintnicolas');

  return (
    <section className="py-14 md:py-20 bg-slate-primary">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10 text-center">
        <div className="w-12 h-12 flex items-center justify-center mx-auto mb-6 md:mb-8">
          <i className="ri-double-quotes-l text-copper text-3xl" />
        </div>

        <blockquote className="text-base md:text-lg lg:text-xl text-white/90 leading-relaxed mb-6 md:mb-8 max-w-3xl mx-auto">
          {t('temoignage_quote')}
        </blockquote>

        <div className="text-white">
          <p className="font-semibold text-sm md:text-base">{t('temoignage_author')}</p>
          <p className="text-white/70 text-xs md:text-sm mt-1">
            {t('temoignage_rue')}, {t('temoignage_city')}
          </p>
          <p className="text-copper text-xs md:text-sm mt-1">{t('temoignage_detail')}</p>
        </div>
      </div>

      <p className="text-white/40 text-xs mt-6 text-center italic max-w-3xl mx-auto">
        Témoignages représentatifs de clients ayant utilisé notre service de mise en relation.
      </p>
    </section>
  );
}